import { EdgePoint } from './orthogonal-edge.util'

export function midpointAlong(points: EdgePoint[]): EdgePoint | null {
  const segments = points.slice(1).map((end, index) => ({
    start: points[index],
    end,
    length: Math.hypot(end.x - points[index].x, end.y - points[index].y),
  }))
  const offsets = segments.map((_, index) =>
    segments.slice(0, index).reduce((sum, segment) => sum + segment.length, 0)
  )
  const half = segments.reduce((sum, segment) => sum + segment.length, 0) / 2
  const index = segments.findIndex((segment, i) => offsets[i] + segment.length >= half)

  if (index < 0) {
    return null
  }

  const { start, end, length } = segments[index]
  const along = length ? (half - offsets[index]) / length : 0

  return { x: start.x + (end.x - start.x) * along, y: start.y + (end.y - start.y) * along }
}
